import React, {PropTypes} from 'react'
import {
  DialogButtonGroup,
  Callout,
} from '~/components/blueprint'

class AssignPrinter extends React.Component {
  static propTypes = {
    action: PropTypes.object.isRequired,
    printers: PropTypes.array.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }
  constructor(props){
    super(props)
    this.handleSelectAllChange = this.handleSelectAllChange.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSave = this.handleSave.bind(this)
    let selectedPrinters = []
    Object.assign(selectedPrinters, props.action.target.printers)
    this.state = {
      selected: selectedPrinters.map(printer=>printer.id)
    }
  }
  handleSelectAllChange(event){
    let selected = event.target.checked ? this.props.printers.map(printer=>printer.id) : []
    this.setState({selected})
  }
  handleChange(printer, event){
    let {selected} = this.state
    if (event.target.checked){
      selected.push(printer.id)
    } else {
      selected = selected.filter(id=>printer.id !== id)
    }
    this.setState({selected})
  }
  handleSave(){
    // let printers = this.props.printers.filter(printer => this.state.selected.includes(printer.id))
    let printers = this.props.printers.filter(printer => this.state.selected.indexOf(printer.id) >= 0)
    let {target} = this.props.action
    target.printers = printers
    this.props.onSave(target)
  }
  render(){
    let {printers, onCancel, action} = this.props
    let {selected} = this.state
    return (
      <div className="dialog-container">
        <table className="pt-table" width="100%">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  // checked={printers.every(({id})=>selected.includes(id))}
                  checked={printers.every(({id})=>selected.indexOf(id) >= 0)}
                  onChange={this.handleSelectAllChange}
                />
              </th>
              <th>Name</th>
              <th>Mac Address</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
          {printers.map(printer=>(
            <tr key={printer.id}>
              <td>
                <input
                  type="checkbox"
                  // checked={selected.includes(printer.id)}
                  checked={selected.indexOf(printer.id) >= 0}
                  onChange={(event)=>this.handleChange(printer, event)}
                />
              </td>
              <td>{printer.name}</td>
              <td>{printer.mac_address}</td>
              <td>{printer.details.printer_ip}</td>
            </tr>
          ))}
          </tbody>
        </table>
        <Callout error={action.error}/>
        <DialogButtonGroup onSave={this.handleSave} onCancel={onCancel}/>
      </div>
    )
  }
}

export default AssignPrinter



/** WEBPACK FOOTER **
 ** ./client/pages/kitchen-department/AssignPrinter.js
 **/